import { memo } from "react"
import styled from "styled-components"

const ConstrolSafe = styled.div`
  display: flex;
  padding: 0px;
  justify-content: center;
  align-items: center;
`

const IconArrowUp = () => {
  return (
    <ConstrolSafe>
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="16" viewBox="0 0 28 16" fill="none">
        <path
          d="M14.0002 0.875718C14.2988 0.874308 14.5854 0.993264 14.7952 1.20572L26.7952 13.2057C27.2083 13.649 27.1961 14.3397 26.7677 14.7682C26.3392 15.1966 25.6485 15.2088 25.2052 14.7957L14.0002 3.59072L2.79523 14.7957C2.35197 15.2088 1.66121 15.1966 1.2328 14.7682C0.804378 14.3397 0.792194 13.649 1.20523 13.2057L13.2052 1.20572C13.4151 0.993264 13.7016 0.874308 14.0002 0.875718Z"
          fill="#333333"
        />
      </svg>
    </ConstrolSafe>
  )
}

export default memo(IconArrowUp)
